/**
 * Vocabulário do domínio: etapas do fluxo do Societário, atores, estados, tipos de empresa e de demanda.
 */
export const ESTADOS = ['PR', 'MG', 'SP', 'SC', 'MS'];
export const ESTADO_NOME = {
    PR: 'Paraná',
    MG: 'Minas Gerais',
    SP: 'São Paulo',
    SC: 'Santa Catarina',
    MS: 'Mato Grosso do Sul',
};
export const TIPOS_EMPRESA = ['EI', 'LTDA'];
/** Tipos de demanda do Societário que entram no mesmo painel. Só "abertura" passa pela esteira automática. */
export const TIPOS_DEMANDA = [
    'abertura',
    'alteracao_contratual',
    'baixa',
    'regularizacao_nf',
    'outra',
];
export const TIPO_DEMANDA_INFO = {
    abertura: { titulo: 'Abertura de empresa', curto: 'Abertura' },
    alteracao_contratual: { titulo: 'Alteração contratual', curto: 'Alteração' },
    baixa: { titulo: 'Baixa de empresa', curto: 'Baixa' },
    regularizacao_nf: { titulo: 'Regularização de NF', curto: 'Regul. NF' },
    outra: { titulo: 'Outra demanda societária', curto: 'Outra' },
};
/** Prioridade definida pela equipe, visível no cartão. */
export const PRIORIDADES = ['alta', 'media', 'baixa'];
export const PRIORIDADE_INFO = {
    alta: { titulo: 'Alta prioridade', ordem: 0 },
    media: { titulo: 'Média prioridade', ordem: 1 },
    baixa: { titulo: 'Baixa prioridade', ordem: 2 },
};
/**
 * Etapas do fluxo do Societário, na ordem do quadro. As três primeiras são a entrada automática
 * (formulário, documentos, leitura pela IA); da "triagem" em diante é o fluxo real da equipe, da
 * Junta até o acesso às notas fiscais na prefeitura. A ordem do array é a ordem do fluxo.
 */
export const ETAPAS = [
    'pedido',
    'documentos',
    'ficha_ia',
    'aprovacao',
    'viabilidade',
    'dbe',
    'preenchimento',
    'taxa',
    'ajuste_cliente',
    'taxa_paga',
    'assinaturas',
    'assinado',
    'protocolo',
    'mat_cnpj',
    'assinatura_contador',
    'procuracao',
    'inscricao_municipal',
    'aguardando_cliente_im',
    'im_analise',
    'nf_entrada',
    'nf_acesso',
    'concluida',
];
/** Fases que o cliente vê na página de acompanhamento (as etapas internas são muitas para ele). */
export const FASES = ['cadastro', 'junta', 'cnpj', 'prefeitura', 'concluida'];
export const FASE_INFO = {
    cadastro: {
        numero: 1,
        titulo: 'Documentos e conferência',
        descricaoCliente: 'Recebemos seu pedido e estamos conferindo dados e documentos.',
    },
    junta: {
        numero: 2,
        titulo: 'Junta Comercial',
        descricaoCliente: 'Viabilidade, taxa, assinaturas e protocolo na Junta Comercial.',
    },
    cnpj: { numero: 3, titulo: 'CNPJ', descricaoCliente: 'Emissão do CNPJ na Receita Federal.' },
    prefeitura: {
        numero: 4,
        titulo: 'Prefeitura e notas fiscais',
        descricaoCliente: 'Inscrição municipal e liberação para emitir notas fiscais.',
    },
    concluida: { numero: 5, titulo: 'Concluída', descricaoCliente: 'Empresa aberta.' },
};
export const ETAPA_INFO = {
    pedido: {
        numero: 1,
        titulo: 'Pedido recebido',
        descricaoCliente: 'Recebemos o seu pedido.',
        fase: 'cadastro',
    },
    documentos: {
        numero: 2,
        titulo: 'Documentos e dados',
        descricaoCliente: 'Precisamos dos documentos dos sócios e de algumas respostas.',
        fase: 'cadastro',
    },
    ficha_ia: {
        numero: 3,
        titulo: 'Conferência dos documentos',
        descricaoCliente: 'Estamos lendo e conferindo os documentos enviados.',
        fase: 'cadastro',
    },
    aprovacao: {
        numero: 4,
        titulo: 'Triagem / Análise de dados',
        descricaoCliente: 'Nossa equipe está revisando a ficha da sua empresa.',
        fase: 'cadastro',
    },
    viabilidade: {
        numero: 5,
        titulo: 'Viabilidade protocolada',
        descricaoCliente: 'Consultando nome e endereço na prefeitura e na Junta.',
        fase: 'junta',
    },
    dbe: {
        numero: 6,
        titulo: 'DBE enviado (SP/SC/MS)',
        descricaoCliente: 'Documento Básico de Entrada enviado à Receita Federal.',
        fase: 'junta',
    },
    preenchimento: {
        numero: 7,
        titulo: 'Preenchimento na Junta (FCN)',
        descricaoCliente: 'Preenchendo a ficha e o contrato na Junta Comercial.',
        fase: 'junta',
    },
    taxa: {
        numero: 8,
        titulo: 'Aguardando pgto taxa / Validação prévia',
        descricaoCliente: 'Aguardando o pagamento da taxa da Junta.',
        fase: 'junta',
    },
    ajuste_cliente: {
        numero: 9,
        titulo: 'Ajuste solicitado pelo cliente',
        descricaoCliente: 'Ajustando o processo conforme você pediu.',
        fase: 'junta',
    },
    taxa_paga: {
        numero: 10,
        titulo: 'Taxa paga / Enviar link assinatura',
        descricaoCliente: 'Taxa paga. Preparando o contrato para assinatura.',
        fase: 'junta',
    },
    assinaturas: {
        numero: 11,
        titulo: 'Contrato gerado / Coleta assinaturas',
        descricaoCliente: 'Cada sócio precisa assinar com a conta gov.br.',
        fase: 'junta',
    },
    assinado: {
        numero: 12,
        titulo: 'Processo assinado / Protocolar',
        descricaoCliente: 'Contrato assinado. Protocolando na Junta Comercial.',
        fase: 'junta',
    },
    protocolo: {
        numero: 13,
        titulo: 'Protocolo na Junta',
        descricaoCliente: 'Processo protocolado na Junta Comercial, em análise.',
        fase: 'junta',
    },
    mat_cnpj: {
        numero: 14,
        titulo: 'Finalização CNPJ',
        descricaoCliente: 'Emitindo o CNPJ na Receita Federal.',
        fase: 'cnpj',
    },
    assinatura_contador: {
        numero: 15,
        titulo: 'Verificar assinatura contador',
        descricaoCliente: 'Conferindo a vinculação do contador à empresa.',
        fase: 'cnpj',
    },
    procuracao: {
        numero: 16,
        titulo: 'Solicitar procuração eletrônica',
        descricaoCliente: 'Solicitando a procuração eletrônica na Receita Federal.',
        fase: 'cnpj',
    },
    inscricao_municipal: {
        numero: 17,
        titulo: 'Iniciar inscrição municipal',
        descricaoCliente: 'Iniciando a inscrição municipal na prefeitura.',
        fase: 'prefeitura',
    },
    aguardando_cliente_im: {
        numero: 18,
        titulo: 'Aguardando taxa / documento cliente',
        descricaoCliente: 'Aguardando taxa ou documento para a prefeitura.',
        fase: 'prefeitura',
    },
    im_analise: {
        numero: 19,
        titulo: 'Inscrição municipal em análise',
        descricaoCliente: 'Inscrição municipal em análise na prefeitura.',
        fase: 'prefeitura',
    },
    nf_entrada: {
        numero: 20,
        titulo: 'Dar entrada uso NFs',
        descricaoCliente: 'Solicitando a liberação para emitir notas fiscais.',
        fase: 'prefeitura',
    },
    nf_acesso: {
        numero: 21,
        titulo: 'Acesso uso NF prefeitura',
        descricaoCliente: 'Liberando o acesso ao emissor de notas fiscais.',
        fase: 'prefeitura',
    },
    concluida: {
        numero: 22,
        titulo: 'Concluído',
        descricaoCliente: 'Empresa aberta.',
        fase: 'concluida',
    },
};
/** Sinal de cor do cartão no painel. */
export const SITUACOES = ['andando', 'aguardando_cliente', 'aguardando_junta', 'travada'];
export const ATORES = ['sistema', 'cliente', 'ia', 'robo', 'equipe'];
export const ESTADOS_CIVIS = [
    'solteiro',
    'casado',
    'divorciado',
    'viuvo',
    'uniao_estavel',
];
export const REGIMES_BENS = [
    'comunhao_parcial',
    'comunhao_universal',
    'separacao_total',
    'participacao_final',
];
export const TIPOS_DOCUMENTO = [
    'identidade', // RG ou CNH (frente e verso podem vir em arquivos separados)
    'cpf', // só quando a identidade não traz o CPF
    'comprovante_residencia',
    'certidao_casamento',
    'iptu', // ou inscrição imobiliária do endereço da empresa
    'outro',
];
export const TIPO_DOCUMENTO_INFO = {
    identidade: {
        titulo: 'Documento de identidade',
        instrucao: 'RG ou CNH, frente e verso, foto nítida e sem reflexo.',
        exemplos: 'Pode ser foto do celular ou PDF do app gov.br / CNH Digital.',
    },
    cpf: {
        titulo: 'CPF',
        instrucao: 'Só se o documento de identidade não mostrar o número do CPF.',
        exemplos: 'Cartão do CPF ou comprovante de situação cadastral da Receita.',
    },
    comprovante_residencia: {
        titulo: 'Comprovante de residência',
        instrucao: 'Conta de luz, água, telefone ou internet dos últimos 3 meses, no nome do sócio.',
        exemplos: 'Se estiver em nome de outra pessoa, envie também uma declaração de residência.',
    },
    certidao_casamento: {
        titulo: 'Certidão de casamento',
        instrucao: 'Frente e verso, incluindo averbações se houver.',
        exemplos: 'Para união estável, envie a escritura ou declaração.',
    },
    iptu: {
        titulo: 'IPTU ou inscrição imobiliária do endereço da empresa',
        instrucao: 'Carnê do IPTU ou documento da prefeitura com a inscrição imobiliária do imóvel.',
        exemplos: 'É o endereço onde a empresa vai funcionar, não o do sócio.',
    },
    outro: {
        titulo: 'Outro documento',
        instrucao: 'Documento solicitado pela equipe.',
        exemplos: '',
    },
};
export const STATUS_DOCUMENTO = [
    'pendente', // ainda não enviado
    'enviado', // recebido, aguardando leitura
    'ilegivel', // IA ou equipe considerou ilegível; cliente precisa reenviar
    'extraido', // dados extraídos pela IA
    'aceito', // conferido pela equipe
    'rejeitado', // equipe rejeitou (documento errado, vencido)
];
export const ORIGENS_CAMPO = ['documento', 'cliente', 'ia', 'equipe', 'sistema'];
export const REGIMES_TRIBUTARIOS = ['simples_nacional', 'lucro_presumido', 'lucro_real'];
export const PORTES = ['ME', 'EPP', 'demais'];
export const CANAIS_MENSAGEM = ['whatsapp', 'email', 'portal'];
export function proximaEtapa(etapa) {
    const i = ETAPAS.indexOf(etapa);
    return i >= 0 && i < ETAPAS.length - 1 ? ETAPAS[i + 1] : null;
}
export function etapaAnterior(etapa) {
    const i = ETAPAS.indexOf(etapa);
    return i > 0 ? ETAPAS[i - 1] : null;
}
//# sourceMappingURL=dominio.js.map